import "./states.css";

export default function NotFoundPage() {
  return (
    <div className="wx-state-screen">
      <div className="wx-state-card">
        <h1 className="wx-state-title">ไม่พบหน้าที่ต้องการ</h1>
        <p className="wx-state-body">ลิงก์นี้อาจไม่ถูกต้องหรือหน้านี้ยังไม่เปิดใช้งาน กรุณากลับไปยังหน้าหลัก</p>
        <a className="wx-state-contact" href="/">
          กลับไปหน้าหลัก
        </a>
      </div>
    </div>
  );
}
